export default "__VITE_ASSET__GhvtbHow__"